import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { Division, JobType, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './division.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class DivisionComponent extends RepositoryModal<Division> implements OnInit {
    jobTypes: JobType[] = []

    ngOnInit() {
        this.jobTypes = this.services.data.jobTypes.items.slice().sort((a, b) => a.shortName.localeCompare(b.shortName))
        this.jobTypes.forEach(jobType => {
            jobType['checked'] = jobType.divisionId === this.target.id
            jobType['display'] = jobType.fullName ? `${jobType.shortName} - ${jobType.fullName}` : jobType.shortName
        })
    }

    protected onBeforeSave() {
        this.target.jobTypeIds = this.jobTypes.filter(jobType => jobType['checked']).map(jobType => jobType.id)
        return super.onBeforeSave()
    }
}
